var _defs, _g, _g2, _g3, _path, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelloKeyboard = function SvgHelloKeyboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1250 1300"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hello-keyboard_svg__letter-gradient",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--theme-ui-colors-primary900)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "var(--theme-ui-colors-primary700)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "var(--theme-ui-colors-primary500)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "var(--theme-ui-colors-primary300)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--theme-ui-colors-primary100)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hello-keyboard_svg__sun-gradient-01",
    x1: 854.3,
    x2: 1291.2,
    y1: 998.3,
    y2: 998.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--theme-ui-colors-primary500)",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "var(--theme-ui-colors-primary500)",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "var(--theme-ui-colors-primary700)",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "var(--theme-ui-colors-primary700)",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--theme-ui-colors-primary900)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hello-keyboard_svg__sun-gradient-02",
    x1: 761.4,
    x2: 965.6,
    y1: 1108.3,
    y2: 1108.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--theme-ui-colors-third300)",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "var(--theme-ui-colors-third500)",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "var(--theme-ui-colors-third500)",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "var(--theme-ui-colors-third700)",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "var(--theme-ui-colors-third700)",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--theme-ui-colors-third900)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hello-keyboard_svg__bg-gradient",
    x1: "100%",
    x2: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--theme-ui-colors-secondary900)",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "var(--theme-ui-colors-secondary700)",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "var(--theme-ui-colors-secondary500)",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "var(--theme-ui-colors-secondary300)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--theme-ui-colors-secondary100)",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hello-keyboard_svg__x-axis-gradient",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--theme-ui-colors-primary900)",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "var(--theme-ui-colors-primary700)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "var(--theme-ui-colors-primary500)",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "var(--theme-ui-colors-primary700)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--theme-ui-colors-primary900)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hello-keyboard_svg__y-axis-gradient",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--theme-ui-colors-primary900)",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "var(--theme-ui-colors-primary700)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "var(--theme-ui-colors-primary500)",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "var(--theme-ui-colors-primary700)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--theme-ui-colors-primary900)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hello-keyboard_svg__board-frame-gradient",
    x1: "0%",
    x2: "0%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--theme-ui-colors-third500)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "var(--theme-ui-colors-third700)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--theme-ui-colors-third900)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hello-keyboard_svg__key-gradient-on",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--theme-ui-colors-primary700)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "var(--theme-ui-colors-primary700)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "var(--theme-ui-colors-primary500)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "var(--theme-ui-colors-primary300)",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--theme-ui-colors-primary100)",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hello-keyboard_svg__large-circle"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1072.7,
    cy: 998.3,
    r: 218.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hello-keyboard_svg__small-circle"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 863.5,
    cy: 1108.3,
    r: 102.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hello-keyboard_svg__hex-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1122.965 937.5 625 1225 127.035 937.5v-575L625 75l497.965 287.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hello-keyboard_svg__frame-shading",
    cx: 551.2,
    cy: 929.2,
    r: 419.5,
    fx: 568.1,
    gradientTransform: "matrix(1.06 -.02 0 .24 16.6 712.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--theme-ui-colors-primary700)",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--theme-ui-colors-primary900)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("style", null, ".hello-keyboard_svg__no-fill{fill:none}.hello-keyboard_svg__primary-stroke{stroke:var(--theme-ui-colors-primary100)}.hello-keyboard_svg__thin-stroke{stroke-width:5}.hello-keyboard_svg__keystroke{stroke:var(--theme-ui-colors-primary100);stroke-opacity:.5;stroke-width:2}.hello-keyboard_svg__bg-fill{fill:var(--theme-ui-colors-background)}"))), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__background"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__sun-large",
    clipPath: "url(#hello-keyboard_svg__large-circle)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "hello-keyboard_svg__fill",
    cx: 1072.7,
    cy: 998.3,
    r: 218.4,
    fill: "url(#hello-keyboard_svg__sun-gradient-01)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "hello-keyboard_svg__bg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m884.868 715.852 525.792 223.186-6.564 15.464-525.792-223.185zM864.555 735.041l525.793 223.186-6.564 15.464L857.99 750.505zM844.151 754.19l525.792 223.186-6.564 15.465-525.792-223.186zM823.8 773.471l525.792 223.186-6.564 15.465-525.793-223.186zM803.448 792.752l525.792 223.186-6.564 15.464-525.792-223.185zM783.044 811.902l525.792 223.186-6.564 15.464-525.793-223.186z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__Sun-Red",
    clipPath: "url(#hello-keyboard_svg__small-circle)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "hello-keyboard_svg__fill-2",
    cx: 863.5,
    cy: 1108.3,
    r: 102.1,
    fill: "url(#hello-keyboard_svg__sun-gradient-02)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "hello-keyboard_svg__bg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m950.51 977.571-231.23 133.5-3.9-6.755 231.23-133.5zM961.752 984.244l-231.229 133.5-3.9-6.755 231.23-133.5zM972.958 991.053l-231.229 133.5-3.9-6.755 231.23-133.5zM984.2 997.726l-231.228 133.5-3.9-6.755L980.3 990.97zM995.443 1004.398l-231.229 133.5-3.9-6.755 231.23-133.5zM1006.65 1011.208l-231.23 133.5-3.9-6.755 231.23-133.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__hex"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__hexGrid",
    clipPath: "url(#hello-keyboard_svg__hex-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hello-keyboard_svg__bg-gradient)",
    d: "M0 20h1241.5v1241.5H0z"
  }), /*#__PURE__*/React.createElement("line", {
    x2: "100%",
    y1: "17%",
    y2: "17%",
    stroke: "url(#hello-keyboard_svg__x-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x2: "100%",
    y1: "28%",
    y2: "28%",
    stroke: "url(#hello-keyboard_svg__x-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x2: "100%",
    y1: "39%",
    y2: "39%",
    stroke: "url(#hello-keyboard_svg__x-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x2: "100%",
    y1: "50%",
    y2: "50%",
    stroke: "url(#hello-keyboard_svg__x-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x2: "100%",
    y1: "61%",
    y2: "61%",
    stroke: "url(#hello-keyboard_svg__x-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x2: "100%",
    y1: "72%",
    y2: "72%",
    stroke: "url(#hello-keyboard_svg__x-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x2: "100%",
    y1: "83%",
    y2: "83%",
    stroke: "url(#hello-keyboard_svg__x-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "17%",
    x2: "17%",
    y2: "100%",
    stroke: "url(#hello-keyboard_svg__y-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "28%",
    x2: "28%",
    y2: "100%",
    stroke: "url(#hello-keyboard_svg__y-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "39%",
    x2: "39%",
    y2: "100%",
    stroke: "url(#hello-keyboard_svg__y-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "50%",
    x2: "50%",
    y2: "100%",
    stroke: "url(#hello-keyboard_svg__y-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "61%",
    x2: "61%",
    y2: "100%",
    stroke: "url(#hello-keyboard_svg__y-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "72%",
    x2: "72%",
    y2: "100%",
    stroke: "url(#hello-keyboard_svg__y-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "83%",
    x2: "83%",
    y2: "100%",
    stroke: "url(#hello-keyboard_svg__y-axis-gradient)",
    className: "hello-keyboard_svg__thin-stroke"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1187.917 975 625 1300 62.083 975V325L625 0l562.917 325z",
    className: "hello-keyboard_svg__no-fill hello-keyboard_svg__primary-stroke",
    style: {
      strokeWidth: 7
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1122.965 937.5 625 1225 127.035 937.5v-575L625 75l497.965 287.5z",
    className: "hello-keyboard_svg__no-fill hello-keyboard_svg__primary-stroke hello-keyboard_svg__thin-stroke"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__keyboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__frame"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__frame-shade",
    width: 866,
    height: 366.3,
    x: 189.7,
    y: 673.6,
    fill: "url(#hello-keyboard_svg__frame-shading)",
    rx: 15
  }), /*#__PURE__*/React.createElement("rect", {
    width: 866,
    height: 366.3,
    x: 189.7,
    y: 558.9,
    fill: "url(#hello-keyboard_svg__board-frame-gradient)",
    strokeMiterlimit: 10,
    className: "hello-keyboard_svg__primary-stroke",
    rx: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__row-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__rArrow",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M993.5 866.3h40.8a3.3 3.3 0 0 1 3.3 3.3V882a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.5-13.6v-12.6a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__dArrow",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M940.1 866.3H981a3.3 3.3 0 0 1 3.3 3.3V882a13.6 13.6 0 0 1-13.5 13.6h-20.3a13.6 13.6 0 0 1-13.6-13.6v-12.6a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__lArrow",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M886.8 866.3h40.8a3.3 3.3 0 0 1 3.3 3.3V882a13.6 13.6 0 0 1-13.6 13.6h-20.2a13.6 13.6 0 0 1-13.6-13.6v-12.6a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__uArrow",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M940.1 832.6H981a3.3 3.3 0 0 1 3.3 3.3v12.6a13.6 13.6 0 0 1-13.5 13.6h-20.3a13.6 13.6 0 0 1-13.6-13.6V836a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__rCtrl",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M809 832.6h62.7a3.3 3.3 0 0 1 3.3 3.3v19a13.6 13.6 0 0 1-13.5 13.6h-42.3a13.6 13.6 0 0 1-13.6-13.5v-19a3.3 3.3 0 0 1 3.3-3.4z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__rAlt",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M754.7 832.6h40.8a3.3 3.3 0 0 1 3.3 3.3v19a13.6 13.6 0 0 1-13.5 13.6H765a13.6 13.6 0 0 1-13.6-13.5v-19a3.3 3.3 0 0 1 3.3-3.4z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__space",
    width: 262.4,
    height: 35.9,
    x: 482.2,
    y: 832.6,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__lAlt",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M409.3 832.6h62.8a3.3 3.3 0 0 1 3.3 3.3v19a13.6 13.6 0 0 1-13.5 13.6h-42.3A13.6 13.6 0 0 1 406 855v-19a3.3 3.3 0 0 1 3.3-3.4z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__win",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M355.1 832.6H396a3.3 3.3 0 0 1 3.3 3.3v19a13.6 13.6 0 0 1-13.6 13.6h-20.3A13.6 13.6 0 0 1 352 855v-19a3.3 3.3 0 0 1 3.3-3.4z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__fn",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M301 832.6h40.8a3.3 3.3 0 0 1 3.3 3.3v19a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.5-13.5v-19a3.3 3.3 0 0 1 3.3-3.4z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__lCtrl",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M211.2 832.6h76.4a3.3 3.3 0 0 1 3.3 3.3v19a13.6 13.6 0 0 1-13.6 13.6h-55.8a13.6 13.6 0 0 1-13.6-13.5v-19a3.3 3.3 0 0 1 3.3-3.4z",
    className: "hello-keyboard_svg__keystroke"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__row-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__rShift",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M908.4 782.4h126.3a3.3 3.3 0 0 1 3.3 3.3V811a13.6 13.6 0 0 1-13.6 13.6H918.7A13.6 13.6 0 0 1 905 811v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__question",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M854.2 782.4H895a3.3 3.3 0 0 1 3.3 3.3V811a13.6 13.6 0 0 1-13.6 13.6h-20.2a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__period",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M800 782.4h40.8a3.3 3.3 0 0 1 3.3 3.3V811a13.6 13.6 0 0 1-13.6 13.6h-20.2a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__comma",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M745.8 782.4h40.9a3.3 3.3 0 0 1 3.3 3.3V811a13.6 13.6 0 0 1-13.6 13.6H756a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__m",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M691.7 782.4h40.8a3.3 3.3 0 0 1 3.3 3.3V811a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.5-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__n",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M637.5 782.4h40.8a3.3 3.3 0 0 1 3.3 3.3V811a13.6 13.6 0 0 1-13.6 13.6h-20.2a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__b",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M583.3 782.4h40.8a3.3 3.3 0 0 1 3.3 3.3V811a13.6 13.6 0 0 1-13.6 13.6h-20.2A13.6 13.6 0 0 1 580 811v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__v",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M529.1 782.4H570a3.3 3.3 0 0 1 3.3 3.3V811a13.6 13.6 0 0 1-13.5 13.6h-20.3a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__c",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M475 782.4h40.8a3.3 3.3 0 0 1 3.3 3.3V811a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__x",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M420.8 782.4h40.8a3.3 3.3 0 0 1 3.3 3.3V811a13.6 13.6 0 0 1-13.6 13.6H431a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.4-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__z",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M366.6 782.4h40.8a3.3 3.3 0 0 1 3.3 3.3V811a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.5-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__lShift",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M210.8 782.4h142.4a3.3 3.3 0 0 1 3.3 3.3V811a13.6 13.6 0 0 1-13.6 13.6H221.1a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__row-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__enter",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M925.3 732h109.4a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.6 13.6h-88.8a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__apostraphe",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M871.1 732H912a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__colon",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M817 732h40.8a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.5-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__l",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M762.8 732h40.8a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.6 13.6H773a13.6 13.6 0 0 1-13.5-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__k",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M708.6 732h40.8a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.6 13.6H719a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__j",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M654.4 732h40.8a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.2a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__h",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M600.2 732H641a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.2a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__g",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M546 732h41a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.5-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__f",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M491.9 732h40.8a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.5-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__d",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M437.7 732h40.8a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.6 13.6H448a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__s",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M383.5 732h40.8a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.2a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__a",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M329.3 732h40.8a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.5 13.6h-20.3a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__cap",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M210.8 732H316a3.3 3.3 0 0 1 3.3 3.4v25.4a13.6 13.6 0 0 1-13.6 13.6h-84.6a13.6 13.6 0 0 1-13.5-13.6v-25.4a3.3 3.3 0 0 1 3.2-3.3z",
    className: "hello-keyboard_svg__keystroke"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__row-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__Slash",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M947.3 681.8h87.4a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.6 13.6h-66.8a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__RBracket",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M893.1 681.8H934a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.5-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__LBracket",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M839 681.8h40.8a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.5-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__p",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M784.8 681.8h40.8a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.2a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__o",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M730.6 681.8h40.8a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.6 13.6H741a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__i",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M676.4 681h40.8a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.5 13.6h-20.3a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__u",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M622.2 681.8H663a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.5 13.6h-20.3a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__y",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M568 681.8h41a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.5-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__t",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M513.9 681.8h40.8a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.2a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__r",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M459.7 681.8h40.8a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.6 13.6H470a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__e",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M405.5 681.8h40.8a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.5 13.6h-20.3a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__w",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M351.3 681.8h40.8a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.5 13.6h-20.3a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__q",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M297.2 681.8H338a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.6 13.6h-20.3a13.6 13.6 0 0 1-13.5-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__Tab",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M210.8 681.8h73a3.3 3.3 0 0 1 3.3 3.3v25.4a13.6 13.6 0 0 1-13.6 13.6h-52.4a13.6 13.6 0 0 1-13.6-13.6v-25.4a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__row-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__backspace",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M921 631.5h113.7a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.6 13.5h-93a13.6 13.6 0 0 1-13.6-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg___",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M861 631.5h40.8a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.6 13.5h-20.2a13.6 13.6 0 0 1-13.6-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke",
    "data-name": "="
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg___-",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M806.8 631.5h40.8a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.6 13.5h-20.2a13.6 13.6 0 0 1-13.6-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke",
    "data-name": "-"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg___0",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M752.6 631.5h40.8a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.5 13.5h-20.3a13.6 13.6 0 0 1-13.6-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke",
    "data-name": 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg___9",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M698.4 631.5h40.9a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.6 13.5h-20.3a13.6 13.6 0 0 1-13.6-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke",
    "data-name": 9
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg___8",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M644.3 631.5H685a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.6 13.5h-20.3a13.6 13.6 0 0 1-13.5-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke",
    "data-name": 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg___7",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M590 631.5h41a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.6 13.5h-20.3a13.6 13.6 0 0 1-13.5-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke",
    "data-name": 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg___6",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M535.9 631.5h40.8a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.6 13.5h-20.2a13.6 13.6 0 0 1-13.6-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke",
    "data-name": 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg___5",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M481.7 631.5h40.8a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.6 13.5H492a13.6 13.6 0 0 1-13.6-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke",
    "data-name": 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg___4",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M427.5 631.5h40.8a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.5 13.5h-20.3a13.6 13.6 0 0 1-13.6-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke",
    "data-name": 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg___3",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M373.4 631.5h40.8a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.6 13.5h-20.3a13.6 13.6 0 0 1-13.5-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke",
    "data-name": 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg___2",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M319.2 631.5H360a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.6 13.5h-20.3a13.6 13.6 0 0 1-13.5-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke",
    "data-name": 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg___1",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M265 631.5h40.8a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.6 13.5h-20.2a13.6 13.6 0 0 1-13.6-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke",
    "data-name": 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__til",
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    d: "M210.8 631.5h40.8a3.3 3.3 0 0 1 3.3 3.3v25.5a13.6 13.6 0 0 1-13.6 13.5h-20.2a13.6 13.6 0 0 1-13.6-13.5v-25.5a3.3 3.3 0 0 1 3.3-3.3z",
    className: "hello-keyboard_svg__keystroke"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__row-0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__ESC",
    width: 54.2,
    height: 30.3,
    x: 207,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__F1-F4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__F1",
    width: 44,
    height: 30.3,
    x: 273.8,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__F2",
    width: 44,
    height: 30.3,
    x: 323.8,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__F3",
    width: 44,
    height: 30.3,
    x: 373.7,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__F4",
    width: 44,
    height: 30.3,
    x: 423.7,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__F5-F8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__F5",
    width: 44,
    height: 30.3,
    x: 480.4,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__F6",
    width: 44,
    height: 30.3,
    x: 530.4,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__F7",
    width: 44,
    height: 30.3,
    x: 580.3,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__F8",
    width: 44,
    height: 30.3,
    x: 630.3,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__F9-F12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__F9",
    width: 44,
    height: 30.3,
    x: 687,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__F10",
    width: 44,
    height: 30.3,
    x: 736.9,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__F11",
    width: 44,
    height: 30.3,
    x: 786.9,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__F12",
    width: 44,
    height: 30.3,
    x: 836.8,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__HOME-DEL"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__HOME",
    width: 44,
    height: 30.3,
    x: 893.5,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__END",
    width: 44,
    height: 30.3,
    x: 943.5,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hello-keyboard_svg__DEL",
    width: 44,
    height: 30.3,
    x: 994.5,
    y: 589.2,
    fill: "url(#hello-keyboard_svg__key-gradient-on)",
    className: "hello-keyboard_svg__keystroke",
    rx: 3
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__Hello"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__hello-H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__hello-H-3",
    fill: "url(#hello-keyboard_svg__letter-gradient)",
    d: "M287.4 333.9c3.6 0 5.7 2 5.7 5.7v47.7c0 3.6 2.1 5.7 5.7 5.7h18.4c3.8 0 5.7-2 5.7-5.7v-47.7c0-3.6 2.1-5.7 5.7-5.7H350q5.7 0 5.7 5.7v122.2c0 3.6-1.9 5.7-5.7 5.7h-21.4c-3.6 0-5.7-2.1-5.7-5.7v-30.2q0-5.7-5.7-5.7h-18.3c-3.7 0-5.8 1.9-5.8 5.7v30.2c0 3.6-1.9 5.7-5.7 5.7H266c-3.6 0-5.7-2.1-5.7-5.7V339.6q0-5.7 5.7-5.7z",
    "data-name": "hello-H",
    transform: "translate(57.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__hello-E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__hello-E-3",
    fill: "url(#hello-keyboard_svg__letter-gradient)",
    d: "M479.8 333.9q5.7 0 5.7 5.7V361c0 3.6-1.9 5.7-5.7 5.7h-46.2c-3.6 0-5.7 2-5.7 5.8v6c0 3.7 2 5.8 5.7 5.8h29.6q5.7 0 5.7 5.7v21.4c0 3.6-1.9 5.7-5.7 5.7h-29.6c-3.6 0-5.7 2-5.7 5.8v6c0 3.7 2 5.8 5.7 5.8h46.2q5.7 0 5.7 5.7v21.4q0 5.7-5.7 5.7h-80.2c-3.6 0-5.7-2-5.7-5.7V339.6c0-3.8 2.1-5.7 5.7-5.7z",
    "data-name": "hello-E",
    transform: "translate(57.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__hello-L-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__hello-L-1-3",
    fill: "url(#hello-keyboard_svg__letter-gradient)",
    d: "M546.4 333.9q5.8 0 5.8 5.7v89.3c0 3.7 2 5.8 5.7 5.8h42.6q5.7 0 5.7 5.7v21.4q0 5.7-5.7 5.7H525c-3.6 0-5.7-2.1-5.7-5.7V339.6c0-3.8 2.1-5.7 5.7-5.7z",
    "data-name": "hello-L-1",
    transform: "translate(57.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__hello-L-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__hello-L-2-3",
    fill: "url(#hello-keyboard_svg__letter-gradient)",
    d: "M664.2 333.9q5.7 0 5.7 5.7v89.3c0 3.7 2.1 5.8 5.8 5.8h42.5q5.8 0 5.8 5.7v21.4q0 5.7-5.8 5.7h-75.4c-3.6 0-5.7-2.1-5.7-5.7V339.6c0-3.8 2.1-5.7 5.7-5.7z",
    "data-name": "hello-L-2",
    transform: "translate(57.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hello-keyboard_svg__hello-O"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hello-keyboard_svg__hello-O-light",
    fill: "url(#hello-keyboard_svg__letter-gradient)",
    d: "M848.8 424.5c0 12.6-2.7 46.4-47.9 46.4S753 437.1 753 424.5v-47.7c0-12.6 2.7-46.4 48-46.4s47.8 33.8 47.8 46.4zM816 387c0-14.7-1-23.6-15-23.6s-15.2 9-15.2 23.6v27.5c0 14.7 1 23.7 15.1 23.7s15.1-9 15.1-23.7z",
    transform: "translate(57.5)"
  }))))));
};
export { SvgHelloKeyboard as ReactComponent };
export default __webpack_public_path__ + "static/hello-keyboard.56bff2e9.svg";